import { ClientState } from '@/store';

const state: ClientState = {
  firstName: undefined,
  lastName: undefined,
};

export default state;
